// @storybook-skip: app-specific desktop-web wrapper around StudySessionFeedbackContainer; not reusable
import { useDevice } from "@memorang/ui/useDevice";
import StudySessionFeedbackContainer from "../../../containers/StudySessionFeedbackContainer";

type Props = {
	isSplitLayout: boolean;
};

const DesktopFeedbackPanel = ({ isSplitLayout }: Props) => {
	const { isDesktopWeb } = useDevice();
	if (!isDesktopWeb) {
		return null;
	}
	return <StudySessionFeedbackContainer isSplitLayout={isSplitLayout} />;
};

export default DesktopFeedbackPanel;
